/**
 * PATH: packages/email-hub/src/feature/lib/inboxSweepApi.ts
 * FILE_ID: EMAILHUB-LIB-INBOX-SWEEP-API-001
 * PURPOSE: Thin helpers for inbox-sweep preview + execute endpoints.
 * WHY: InboxSweepStartDialog and tests share one I/O seam; banner owns list/revert.
 * RELATED: InboxSweepBanner.tsx, organisation/views/email_views/inbox_sweep_views.py
 */
import { emailApi } from './api'
import type { InboxSweep } from '../components/InboxSweepBanner'

export interface InboxSweepPreviewPlan {
  account_id: number
  total_visible: number
  kept_count: number
  protected_count: number
  done_count: number
  junk_count: number
  keep_count: number
  protect_job_linked: boolean
  cutoff_received_at: string | null
}

export interface InboxSweepExecuteResult {
  success: boolean
  sweep: InboxSweep
  chunked?: boolean
}

export interface SweepRequestBody {
  account_id: number
  keep_count?: number
  protect_job_linked?: boolean
}

export async function previewInboxSweep(
  body: SweepRequestBody,
): Promise<InboxSweepPreviewPlan> {
  return emailApi<InboxSweepPreviewPlan>('/api/emails/inbox-sweep/preview/', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  })
}

export async function executeInboxSweep(
  body: SweepRequestBody,
): Promise<InboxSweepExecuteResult> {
  return emailApi<InboxSweepExecuteResult>('/api/emails/inbox-sweep/execute/', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  })
}

/** Extract a stable status code from emailApi / fetch failures. */
export function sweepErrorStatus(err: unknown): number | null {
  if (!err || typeof err !== 'object') return null
  const e = err as { status?: number; response?: { status?: number } }
  if (typeof e.status === 'number') return e.status
  if (typeof e.response?.status === 'number') return e.response.status
  return null
}
